var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { ENTER_KEY, SPACE_KEY } from '#constants';
import { C } from '#integrations';
import { useHandleFocus } from '../../hooks';
import styles from './Th.module.css';
export const Th = ({ ariaLabel, ariaSort, children, className, 'data-testid': testId, isFocusable = false, onClick, }) => {
    _react_refresh_temp_2();
    // The tabindex is managed by the Table's arrow-key navigation (roving
    // tabindex) rather than being hardcoded, so the header row participates in
    // the same cell navigation as the data rows.
    const ref = useHandleFocus(isFocusable);
    const handleKeyDown = onClick
        ? (event) => {
            if (event.key === ENTER_KEY || event.key === SPACE_KEY) {
                event.preventDefault();
                onClick();
            }
        }
        : undefined;
    return (_jsx("th", { "aria-label": ariaLabel, "aria-sort": ariaSort, className: C(styles.Container, className, onClick && styles.Pointer), "data-testid": `table-column-header-${testId}`, onClick: onClick, onKeyDown: handleKeyDown, ref: ref, children: children }));
};
_react_refresh_temp_1 = Th;
$RefreshReg$(_react_refresh_temp_1, "Th");
_react_refresh_temp_2(Th, "cs6VrqWjsrrLE7Fq6h+HdpcVL2w=", false, () => [useHandleFocus]);
